import { fromJS } from 'immutable';
import {
  SAVE_PROPOSAL,
  SAVE_QUOTATION_SUCCESS,
  SAVE_QUOTATION_ERROR,
  SAVE_PROPOSAL_SUCCESS,
  SAVE_PROPOSAL_ERROR,
  UPDATE_QUOTATION,
  CUSTOMER_RECEIVED,
  CUSTOMER_FOUND,
  UPDATE_CUSTOMER_INPUT,
  RESET_CUSTOMER,
  SET_UPDATED,
} from './constants';
import {
  QUOTATION_RECEIVED,
} from 'containers/Quotation/constants';

export const initialState = fromJS({
  loading: false,
  quotation: {},
  attachments: {},
  search: false,
  customerCode: '',
  contractualCategory: null,
  customer: {},
  customerUpdatedInput: {},
  errors: {},
  hasErrors: false,
  updated: false
});

function quotationReducer(state = initialState, action) {
  switch (action.type) {
    case SAVE_PROPOSAL:
      return state.set('quotation', action.proposal).set('loading', true);
    // case SAVE_QUOTATION:
    //   return state.set('quotation', action.quotation).set('loading', true);
    case UPDATE_QUOTATION:
      return state
        .set('quotation', action.quotation)
        .set('customer', action.customer)
        .set('loading', true);
    case SAVE_PROPOSAL_SUCCESS:
    case SAVE_QUOTATION_SUCCESS:
      return state
        .set('quotation', action.quotation)
        .set('customerUpdatedInput', {})
        .set('errors', {})
        .set('hasErrors', false)
        .set('loading', false);
    case SAVE_PROPOSAL_ERROR:
    case SAVE_QUOTATION_ERROR:
      return state
        .set('errors', action.errors)
        .set('hasErrors', true)
        .set('loading', false);
    case SET_UPDATED:
      return state.set('updated', action.value);
    case CUSTOMER_FOUND:
      return state.set('customerFound', action.found).set('customerUpdatedInput', {});
    case CUSTOMER_RECEIVED:
      return state.set('customer', action.customer).set('customerUpdatedInput', {}).set('search', false);
    case RESET_CUSTOMER:
      return state.set('customerFound', false).set('customer', {}).set('customerUpdatedInput', {});
    case UPDATE_CUSTOMER_INPUT:
        return state.set('customerUpdatedInput', {...state.get('customerUpdatedInput'), [action.field]: action.value});
    case QUOTATION_RECEIVED:
        return state.set('customerUpdatedInput', {});
    default:
      return state;
  }
}

export default quotationReducer;
